import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AdminOtpVerification = () => {
    const { t } = useTranslation()
    const OTP_LENGTH = 4;
    const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
    const [timer, setTimer] = useState(59);
    const inputRefs = useRef([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [timer]);

    const handleChange = (index, e) => {
        const value = e.target.value;
        if (value.match(/^[0-9]$/)) {
            let newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (index < otp.length - 1) {
                inputRefs.current[index + 1]?.focus();
            } else if (otp.length === OTP_LENGTH) {
                navigate('/admin/userlist')
            }
        } else if (value === "") {
            let newOtp = [...otp];
            newOtp[index] = "";
            setOtp(newOtp);
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    return (
        <div className="flex flex-1 items-center justify-center  px-4">
            <div className="bg-white px-6 py-28 md:p-8 shadow-lg rounded-2xl w-full max-w-md text-center">
                <h2 className="text-lg font-semibold mb-2 max-w-60 lg:max-w-full mx-auto">
                    {t("opth1")}
                </h2>
                <p className="text-gray-600 text-sm mt-5">
                    {t("otpdes")}
                </p>

                {/* OTP Input Boxes */}
                <div className="flex justify-center gap-2 my-10">
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            ref={(el) => (inputRefs.current[index] = el)}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleChange(index, e)}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            className="w-12 h-12 text-center text-xl border border-black rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                    ))}
                </div>

                {/* Resend Code */}
                <div className="mt-4">
                    {timer > 0 ? (
                        <p className="text-gray-400 text-sm">
                            {t("otpcode")} ({timer} {t("seconds")})
                        </p>
                    ) : (
                        <button
                            className="text-blue-500 text-sm hover:underline"
                            onClick={() => setTimer(59)}
                        >
                            {t("otpcode")}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminOtpVerification;
